import axios from 'axios';

const BASE_URL = 'https://api.github.com';
const GITHUB_TOKEN = "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"

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${GITHUB_TOKEN}`,
        'X-GitHub-Api-Version':'2022-11-28'
    },
    });
export default axiosInstance
